<template>
<div class="vue-vehicle-details">
    <div v-if="item.fuel.label || item.amount_of_doors || item.amount_of_persons || item.suitcases || item.transmission.label" class="vehicle-details">
        <div v-if="item.fuel.label" class="fuel">
            <span>{{ item.fuel.label }}</span>
        </div>

        <div v-if="item.amount_of_doors" class="doors">
            <span>{{ item.amount_of_doors }} {{ translations.doorsText }}</span>
        </div>

        <div v-if="item.suitcases" class="suitcases">
            <span>{{ item.suitcases }} {{ translations.suitcasesText }}</span>
        </div>

        <div v-if="item.amount_of_persons" class="persons">
            <span>{{ item.amount_of_persons }} {{ translations.personsText }}</span>
        </div>

        <div v-if="item.transmission.label" class="transmission">
            <span>{{ item.transmission.label }}</span>
        </div>

        <div v-if="item.cargo_space" class="cargo-space">
            <span>{{ item.cargo_space }} {{ translations.cargoSpaceLabel }}</span>
        </div>

        <div v-if="item.drivers_licenses" class="drivers-licenses">
            <span>{{ translations.driversLicenseLabel }} ({{ item.drivers_licenses.join(',') }})</span>
        </div>
    </div>
</div>
</template>

<script>
import translations from "../../mixins/translations";

export default {
    name: "Details",

    props: ['item'],

    mixins: [translations]
}
</script>